module.exports = {
    JWTConfig : require('./libs/JWTConfig'),
    Base64Url : require('./libs/JWTConfig'),
    JWTParser : require('./libs/JWTParser'),
    JWTGenerator : require('./libs/JWTGenerator'),
    JWTAuth : require('./libs/JWTAuth')
}